import { forwardRef } from "react";
import classNames from "classnames";
import { Division, Heading } from "@ir/ui";
import {
  Breadcrumb,
  type BreadcrumbProps,
} from "@src/presentation/components/common";

interface PageHeadingProps {
  title?: string;
  className?: string;
  children?: React.ReactNode;
  borderBottom?: boolean;
  /** When set, renders Breadcrumb after header content; omit to hide. */
  breadcrumb?: BreadcrumbProps;
}

const PageHeading = forwardRef<HTMLDivElement, PageHeadingProps>(
  ({ title, className, children, borderBottom = true, breadcrumb }, ref) => {
    const mainContentHeaderClass = classNames(
      "main-content-header bg-white",
      { "border-bottom-1 border-color-grey-50": borderBottom },
      className,
    );

    return (
      <Division className={mainContentHeaderClass} ref={ref}>
        {title && <Heading text={title} level={5} className="m-0 font-bold" />}
        {children}
        {breadcrumb ? <Breadcrumb className="mt-2" {...breadcrumb} /> : null}
      </Division>
    );
  },
);

export default PageHeading;
